import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getHomeRouteForRole } from "./homeRoute";
import RouteFallback from "../ui/RouteFallback";

const AdminRoute = () => {
  const { token, userRole, authChecked } = useAuth();
  const location = useLocation();

  if (!authChecked) return <RouteFallback />;

  if (!token) {
    return (
      <Navigate to="/login" replace state={{ from: location.pathname }} />
    );
  }

  if (userRole !== "SuperAdmin") {
    return <Navigate to={getHomeRouteForRole(userRole)} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
